/**
 * Component event channel — engine to UI signaling only.
 * Never use for engine-to-engine communication — use EngineEvents for that.
 */
export const ComponentEvents = {
    /**
     * Root pubsub channel for all component events.
     * Engines publish here, components subscribe and filter on target.
     */
    channel: 'OnComponentEvent',

    /**
     * Triggers a repaint on a named component.
     */
    onRepaint: 'OnRepaint',
};
